<template>
  <div style="overflow-x: auto;overflow-y: hidden;">
    <v-card class="ma-6 mb-0 pa-6" v-if="isDisplayFilter" outlined>
      <ClassTimeTableFilter @onFilterChanged="getClassSlots" />
    </v-card>
    <h2 class="py-6 text-center" v-else>Thời khóa biểu lớp {{ profile.ownClasses[0].title }}</h2>
    <TimeTableTable :slots="classSlots" :selectedClassId="selectedClassId" type="class" />
    <TimeTableBlankView type="class" v-if="!selectedClassId && isDisplayFilter" class="ma-6 pa-6" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ClassTimeTableFilter from './ClassTimeTableFilter.vue'
import TimeTableTable from '@/modules/timeTable/TimeTableTable.vue'
import TimeTableBlankView from '@/modules/timeTable/TimeTableBlankView.vue'
import get from 'lodash-es/get'

export default {
  components: {
    TimeTableTable,
    ClassTimeTableFilter,
    TimeTableBlankView
  },
  data() {
    return {
      grade: null,
      selectedClassId: '',
      createState: false
    }
  },
  computed: {
    ...mapState('timeTable', ['classSlots', 'teacherSlots']),
    ...mapGetters('auth', ['profile', 'role']),
    isDisplayFilter() {
      if (this.role.type === 'teacher' && this.profile.ownClasses && this.profile.ownClasses.length === 1) {
        return false
      }
      return true
    }
  },
  async mounted() {
    if (!this.isDisplayFilter) {
      this.selectedClassId = this.profile.ownClasses[0].id
      await this.fetchClassSlots({ class: this.selectedClassId })
    }
  },
  methods: {
    ...mapActions('timeTable', ['fetchClassSlots', 'fetchTeacherSlots', 'removeSlot', 'setSelectedClassId']),
    async getClassSlots(data) {
      this.selectedClassId = get(data.class, 'id', '')
      this.setSelectedClassId(this.selectedClassId)
      if (this.selectedClassId) {
        await this.fetchClassSlots({ class: this.selectedClassId })
      }
    }
  },
  beforeDestroy() {
    this.setSelectedClassId('')
  }
}
</script>
<style lang="scss" scoped></style>
